import React from 'react';

import Header from './Header';
import Row from './Row';

import InterestUri from '../../../Enum/InterestUri';
import { HeaderCell, Row as RowInterface } from '../../../Interface/Hook/Interest/InterestTableDTO';
import { Sort } from '../../../Interface/Table/Sort';

import scopeTableData from '../../../Service/ScopeTableData';
import sortTableData from '../../../Service/SortTableData';

interface Props {
    className?: string;
    data: RowInterface[];
    headers: HeaderCell[];
    scopable?: boolean;
    section?: InterestUri;
    sort?: Sort;
}

const Table: React.FC<Props> = ({ className, data, headers, scopable, section, sort }: Props) => (
    <div className="interest-table-wrapper">
        <table className={`interest-table ${className || ''}`} data-testid="interest-table" id="table">
            <Header data={headers} section={section} sort={sort} />
            <tbody>
                {scopable && scopeTableData(data).map((row, index) => <Row data={row} key={index} />)}
                {!scopable && sortTableData(data, headers, sort).map((row, index) => <Row data={row} key={index} />)}
            </tbody>
        </table>
    </div>
);

export default Table;
